function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends.apply(this, arguments);
}

import isPlainObject from "./utils/isPlainObject";
/**
 * Turns an object whose values are action creator, into an object with the
 * same keys, but with every function wrapped into a `dispatch` call so they
 * may be invoked directly.
 *
 * @param {Object} actionCreators An object whose values are action
 * creator functions or plain objects whose values are action creator functions
 *
 * @param {Function} dispatch The `dispatch` function available on your Redhooks
 * store.
 *
 * @returns {Object} if passed may be either a function that must return a plain object
 * whose values are functions or a plain object whose values are action creator functions
 */

var bindActionCreators = function bindActionCreators(actionCreators, dispatch) {
  if (!isPlainObject(actionCreators)) {
    throw new Error(errMsg("First", "must be a plain object", actionCreators));
  }

  if (typeof dispatch !== "function") {
    throw new Error(errMsg("Second", "must be a function", dispatch));
  }

  return Object.keys(actionCreators).reduce(function (acc, key) {
    var value = actionCreators[key];

    if (typeof value === "function") {
      var _extends2;

      return _extends({}, acc, (_extends2 = {}, _extends2[key] = function () {
        return dispatch(value.apply(void 0, arguments));
      }, _extends2));
    } else if (isPlainObject(value)) {
      var _extends3;

      return _extends({}, acc, (_extends3 = {}, _extends3[key] = _extends({}, bindActionCreators(value, dispatch)), _extends3));
    }

    return acc;
  }, {});
};

export default bindActionCreators;

function errMsg(argNumber, text, prop) {
  return argNumber + " argument in bindActionCreators() " + text + ". Instead received " + typeof prop + " => " + prop + ".";
}